// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../pins-not-registered/state/criteria';
import actions from '../../actions-list';

const updatePinsNotRegisteredCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const reset = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_PINS_NOT_REGISTERED_CRITERIA]: reset,
        [actions.UPDATE_PINS_NOT_REGISTERED_CRITERIA]: updatePinsNotRegisteredCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/reducers/criteria.js